<div class="navigation-buttons">
  <ng-container *ngFor="let button of buttons">
    <button
      (click)="onClickOnButton(button)"
      *ngIf="isButtonActive(button); else nonActiveButton"
      class="lbShadowSmall"
      color="primary"
      mat-flat-button
    >
      <mat-icon>done</mat-icon>
      <span>{{ button.label | translate }}</span>
    </button>

    <ng-template #nonActiveButton>
      <button (click)="onClickOnButton(button)" color="primary" mat-stroked-button>
        <span>{{ button.label | translate }}</span>
      </button>
    </ng-template>
  </ng-container>
</div>
